import React from 'react'
import { SanityFactBox, SanityFactBoxItem } from '../../types/generated/graphql-types'
import { FactBoxProps, Variant } from '../components/FactBox'
import { RichTextArea } from '../components/PortableText/RichTextArea'
import { FactboxBlockSerializer } from '../components/PortableText/serializers/blocks/FactboxBlockSerializer'
import { BasicImageSerializer } from '../components/PortableText/serializers/componentTypes/BasicImageSerializer'
import { FactboxListItemSerializer } from '../components/PortableText/serializers/lists/FactboxListItemSerializer'
import { FactboxListSerializer } from '../components/PortableText/serializers/lists/FactboxListSerializer'
import { notEmpty } from '../utilities/filters'
import { isNullOrWhiteSpace } from '../utilities/string'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const sanityFactBoxToFactBoxProps = ({
  _rawBody,
  body,
  list,
  title,
  type,
}: SanityFactBox): FactBoxProps => {
  const bodyField = _rawBody ?? body

  return {
    body: bodyField ? (
      <RichTextArea
        components={{
          block: FactboxBlockSerializer,
          list: FactboxListSerializer,
          listItem: FactboxListItemSerializer,
          types: {
            basicImage: props => (
              <BasicImageSerializer {...props.value} variant="factBox" />
            ),
          },
        }}
        value={bodyField}
      />
    ) : undefined,
    heading: title ?? undefined,
    items: list?.filter(notEmpty)?.map(item => ({
      heading: item?.title,
      link: factBoxLinkToProps(item),
      linkText: item.linkText ?? undefined,
      text: item?.body ?? '',
    })),
    variant: type as Variant,
  }
}

const factBoxLinkToProps = (item: SanityFactBoxItem): string | undefined => {
  const latestLink =
    (item.latestLink && mapSanityLinkToInternalExternalLink(item.latestLink)?.url) ??
    undefined

  const deprecatedLink = item?.link?.page?.path ?? undefined

  return !isNullOrWhiteSpace(latestLink) ? latestLink : deprecatedLink
}
